// The routes this module owns, as the app mounts them. `route.ts` takes its mount from here and
// `src/app/paths.ts` merges this into the one `paths` object, so a link and a route cannot drift.
export const aesPaths = {
  base: '/services/aes',
} as const;
